<form [formGroup]="newFoodForm" class="container mt-3">

  @if(isFoodAddedSuccessfully){
  <div class="alert alert-success alert-dismissible fade show" role="alert">
    <strong>Well done!</strong> You added a food entry to your meal plan. Click on the <strong>"Meal Plan"</strong> tab to review your entries.
    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
  </div>
  }
  @else{
  @if(duplicateFoodName){
  <div class="alert alert-danger alert-dismissible fade show" role="alert">
    <strong>Oh no!</strong> The food name you entered already exists. Please enter a different food name.
    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
  </div>
  }
  @else if(somethingWentWrong){
  <div class="alert alert-danger alert-dismissible fade show" role="alert">
    <strong>Oh no!</strong> There was an error adding the food entry. Please try again.
    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
  </div>
  }
  }

  <div class="row">
    <div class="col">
      <div class="form-floating mb-3">
        <input id="foodNameInput" [formControl]="this.newFoodForm.controls.name" type="text" class="form-control" placeholder="For example, Cheese Pizza" value="">
        <label for="foodNameInput">Food Name</label>
      </div>
      <div *ngIf="this.newFoodForm.controls.name.invalid && (this.newFoodForm.controls.name.dirty || this.newFoodForm.controls.name.touched)" class="alert alert-danger">
        <div *ngIf="this.newFoodForm.controls.name.hasError('required')">
          The food name is required.
        </div>
        <div *ngIf="this.newFoodForm.controls.name.hasError('maxlength')">
          The food name must be less than 150 characters.
        </div>
      </div>
    </div>
    <div class="col">
      <select id="unitOfMeasureInput" [formControl]="this.newFoodForm.controls.unitsOfMeasureId" class="form-select py-3" aria-label="Select a unit of measure" value="0">
        <option value="">Unit of Measure</option>
        <option value="1">Grams (g)</option>
        <option value="2">Ounces (oz)</option>
        <option value="3">Each (ea)</option>
        <option value="4">Cups (c)</option>
        <option value="5">Tablespoons (Tbsp)</option>
        <option value="6">Teaspoons (tsp)</option>
        <option value="7">Pint (pt)</option>
        <option value="8">Pounds (lb)</option>
        <option value="9">Milliliters (ml)</option>
        <option value="10">Fluid Ounces (fl oz)</option>
      </select>
      <div *ngIf="this.newFoodForm.controls.unitsOfMeasureId.invalid && (this.newFoodForm.controls.unitsOfMeasureId.dirty || this.newFoodForm.controls.unitsOfMeasureId.touched)" class="alert alert-danger">
        <div *ngIf="this.newFoodForm.controls.unitsOfMeasureId.hasError('required')">
          Unit of Measure is required.
        </div>
        <div *ngIf="this.newFoodForm.controls.unitsOfMeasureId.hasError('min') || this.newFoodForm.controls.unitsOfMeasureId.hasError('max')">
          Please select a valid unit of measure.
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <div class="form-floating mb-3">
        <input id="servingSizeInput" [formControl]="this.newFoodForm.controls.servingSize" type="number" class="form-control" placeholder="0" value="0" min="0">
        <label for="servingSizeInput">Serving Size</label>
      </div>
      <div *ngIf="this.newFoodForm.controls.servingSize.invalid && (this.newFoodForm.controls.servingSize.dirty || this.newFoodForm.controls.servingSize.touched)" class="alert alert-danger">
        <div *ngIf="this.newFoodForm.controls.servingSize.hasError('required')">
          Serving size is required.
        </div>
        <div *ngIf="this.newFoodForm.controls.servingSize.hasError('min') || this.newFoodForm.controls.servingSize.hasError('max')">
          The serving size must be between 1 and 2000.
        </div>
      </div>
    </div>
    <div class="col">
      <div class="form-floating mb-3">
        <input id="carbsInput" [formControl]="this.newFoodForm.controls.carbs" type="number" (change)="updateNetCarbs()" class="form-control" placeholder="0" value="0" min="0">
        <label for="carbsInput">Carbohydrates</label>
      </div>
      <div *ngIf="this.newFoodForm.controls.carbs.invalid && (this.newFoodForm.controls.carbs.dirty || this.newFoodForm.controls.carbs.touched)" class="alert alert-danger">
        <div *ngIf="this.newFoodForm.controls.carbs.hasError('required')">
          Carbohydrates is required.
        </div>
        <div *ngIf="this.newFoodForm.controls.carbs.hasError('min') || this.newFoodForm.controls.carbs.hasError('max')">
          Carbohydrates must be between 0 and 1000.
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <div class="form-floating mb-3">
        <input id="fiberInput" [formControl]="this.newFoodForm.controls.fiber" (change)="updateNetCarbs()" type="number" class="form-control" placeholder="0" value="0" min="0">
        <label for="fiberInput">Fiber</label>
      </div>
      <div *ngIf="this.newFoodForm.controls.fiber.invalid && (this.newFoodForm.controls.fiber.dirty || this.newFoodForm.controls.fiber.touched)" class="alert alert-danger">
        <div *ngIf="this.newFoodForm.controls.fiber.hasError('required')">
          Fiber is required.
        </div>
        <div *ngIf="this.newFoodForm.controls.fiber.hasError('min') || this.newFoodForm.controls.fiber.hasError('max')">
          Fiber must be between 0 and 1000.
        </div>
      </div>
    </div>
    <div class="col">
      <div class="form-floating mb-3">
        <input id="netCarbsInput" [formControl]="this.newFoodForm.controls.netcarbs" type="number" class="form-control" placeholder="0" value="0" min="0">
        <label for="netCarbsInput">Net Carbohydrates</label>
      </div>
      <div *ngIf="this.newFoodForm.controls.netcarbs.invalid && (this.newFoodForm.controls.netcarbs.dirty || this.newFoodForm.controls.netcarbs.touched)" class="alert alert-danger">
        <div *ngIf="this.newFoodForm.controls.netcarbs.hasError('required')">
          Net carbohydrates is required.
        </div>
        <div *ngIf="this.newFoodForm.controls.netcarbs.hasError('min') || this.newFoodForm.controls.netcarbs.hasError('max')">
          Net carbohydrates must be between 0 and 1000.
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <div class="form-floating mb-3">
        <input id="fatInput" [formControl]="this.newFoodForm.controls.fat" (change)="updateCalories()" type="number" class="form-control" placeholder="0" value="0" min="0">
        <label for="fatInput">Fat</label>
      </div>
      <div *ngIf="this.newFoodForm.controls.fat.invalid && (this.newFoodForm.controls.fat.dirty || this.newFoodForm.controls.fat.touched)" class="alert alert-danger">
        <div *ngIf="this.newFoodForm.controls.fat.hasError('required')">
          Fat is required.
        </div>
        <div *ngIf="this.newFoodForm.controls.fat.hasError('min') || this.newFoodForm.controls.fat.hasError('max')">
          Fat must be between 0 and 1000.
        </div>
      </div>
    </div>
    <div class="col">
      <div class="form-floating mb-3">
        <input id="proteinInput" [formControl]="this.newFoodForm.controls.protein" (change)="updateCalories()" type="number" class="form-control" placeholder="0" value="0" min="0">
        <label for="proteinInput">Protein</label>
      </div>
      <div *ngIf="this.newFoodForm.controls.protein.invalid && (this.newFoodForm.controls.protein.dirty || this.newFoodForm.controls.protein.touched)" class="alert alert-danger">
        <div *ngIf="this.newFoodForm.controls.protein.hasError('required')">
          Protein is required.
        </div>
        <div *ngIf="this.newFoodForm.controls.protein.hasError('min') || this.newFoodForm.controls.protein.hasError('max')">
          Protein must be between 0 and 1000.
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <div class="form-floating mb-3">
        <input id="alcoholInput" [formControl]="this.newFoodForm.controls.alcohol" (change)="updateCalories()" type="number" class="form-control" placeholder="0" value="0" min="0">
        <label for="alcoholInput">Alcohol</label>
      </div>
      <div *ngIf="this.newFoodForm.controls.alcohol.invalid && (this.newFoodForm.controls.alcohol.dirty || this.newFoodForm.controls.alcohol.touched)" class="alert alert-danger">
        <div *ngIf="this.newFoodForm.controls.alcohol.hasError('required')">
          Alcohol is required.
        </div>
        <div *ngIf="this.newFoodForm.controls.alcohol.hasError('min') || this.newFoodForm.controls.alcohol.hasError('max')">
          Alcohol must be between 0 and 1000.
        </div>
      </div>
    </div>
    <div class="col">
      <div class="form-floating mb-3">
        <input id="caloriesInput" [formControl]="this.newFoodForm.controls.calories" type="number" class="form-control" placeholder="0" value="0" min="0">
        <label for="caloriesInput">Calories</label>
      </div>
      <div *ngIf="this.newFoodForm.controls.calories.invalid && (this.newFoodForm.controls.calories.dirty || this.newFoodForm.controls.calories.touched)" class="alert alert-danger">
        <div *ngIf="this.newFoodForm.controls.calories.hasError('required')">
          Calories are required.
        </div>
        <div *ngIf="this.newFoodForm.controls.calories.hasError('min') || this.newFoodForm.controls.calories.hasError('max')">
          Calories must be between 0 and 10,000.
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <button type="submit" class="btn btn-primary" (click)="saveNewFood()" [disabled]="this.newFoodForm.invalid">Save</button>
    </div>
  </div>

</form>
